<template>
  <div>
    <ion-card class="ion-no-margin">
      <!-- No suggestion available -->
      <ion-card-content v-if="!suggestion">
        <span>Aucune {{ title.toLowerCase() }} disponible</span>
      </ion-card-content>

      <!-- Suggestion applied -->
      <ion-card-content
        v-else-if="suggestion && value === suggestion"
        class="flex"
      >
        <div>
          <span>{{ title }} appliquée&nbsp;:&nbsp;</span>
          <strong>{{ suggestion }}</strong>
        </div>

        <ion-button
          class="delete"
          size="small"
          :disabled="disabled"
          @click="$emit('update:value', null)"
        >
          Supprimer
        </ion-button>
      </ion-card-content>

      <!-- Suggestion available but not applied -->
      <ion-card-content v-else>
        <div class="flex">
          <div>
            <span>{{ title }} calculée&nbsp;:&nbsp;</span>
            <strong>{{ suggestion }}</strong>
          </div>
          <ion-button
            class="validate"
            size="small"
            :disabled="disabled"
            @click="$emit('update:value', suggestion)"
          >
            Valider
          </ion-button>
        </div>
      </ion-card-content>
    </ion-card>

    <small v-if="suggestion && value !== suggestion">
      <em>
        Si la {{ title.toLowerCase() }} mentionnée est correcte, nous vous
        invitons à la valider afin qu’elle soit prise en compte. Dans le cas
        contraire, merci d’indiquer la {{ title.toLowerCase() }} correcte en
        commentaire.
      </em>
    </small>
  </div>
</template>

<script>
import { IonButton, IonCard, IonCardContent } from '@ionic/vue';

export default {
  name: 'Suggestion',

  components: {
    IonButton,
    IonCard,
    IonCardContent,
  },

  props: {
    title: String,
    value: String,
    suggestion: String,
    disabled: Boolean,
  },

  emits: ['update:value'],
};
</script>

<style scoped lang="scss">
ion-button {
  text-transform: none;
  --box-shadow: none;

  &.validate {
    --background: #ffe08d;
    --color: #241a00;
  }

  &.delete {
    --background: #ffdad6;
    --color: #ba1a1a;
  }
}

.flex {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

em {
  color: #737373;
}
</style>
